export default "__VITE_ASSET__BacfnQcj__"